(() => {
if (window.__abrsmFeaturedCollectionRuntime) {
  window.__abrsmFeaturedCollectionRuntime.initAll();
  return;
}

const rootSelector = '.abrsm-featured-products';

const readConfig = (root) => {
  const configNode = root.querySelector('[data-afp-config]');
  if (!configNode) return null;
  try {
    return JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    console.error('Featured collection configuration could not be read.', error);
    return null;
  }
};

const initFeaturedCollection = (root) => {
  const config = readConfig(root);
  if (!config) return null;
  const sectionId = String(config.sectionId || root.dataset.sectionId || '');
  if (!sectionId) return null;
  window._abrsmFeatured = window._abrsmFeatured || {};
  if (root.dataset.afpRuntimeInitialized === 'true' && window._abrsmFeatured[sectionId]) {
    return window._abrsmFeatured[sectionId];
  }
// Cleanup previous instance if any
  window._abrsmFeatured = window._abrsmFeatured || {};
  if (window._abrsmFeatured[sectionId] && typeof window._abrsmFeatured[sectionId].destroy === 'function') {
    window._abrsmFeatured[sectionId].destroy();
  }

  // Helper: money formatting
  function formatMoneyFromCents(cents, currency) {
    try {
      var amount = (Number(cents) || 0) / 100;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'GBP', currencyDisplay: 'symbol' }).format(amount);
    } catch (e) {
      return '£' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  // Helper: insert soft breaks into long titles
  function smartBreakTitle(el) {
    if (!el || !el.textContent) return;
    var txt = el.textContent;
    // Insert zero-width spaces after common separators to allow breaks
    txt = txt.replace(/([:/–—\-|·•()])/g, '$1\u200B');
    el.textContent = txt;
  }

  // Instance
  var instance = (function (root) {
    var track = root.querySelector('.afp-grid');
    if (!track) return {};

    var prevBtn = root.querySelector('.afp-carousel-prev');
    var nextBtn = root.querySelector('.afp-carousel-next');
    var dotsWrap = root.querySelector('.afp-carousel-dots');

    var dataMode = (track.getAttribute('data-mode') || 'collection');
    var limit = Number(track.getAttribute('data-limit') || 8);

    // Only count actual product cards as slides (excludes other content like view-all)
    var slides = Array.prototype.slice.call(track.querySelectorAll('.afp-card') || []);
    var totalSlides = slides.length;

    // Settings
    var settings = Object.assign({}, config.settings || {}, {
      currency: root.getAttribute('data-currency') || 'GBP',
      dataMode: dataMode
    });

    // State
    var raf = null;
    var resizeTimer = null;
    var autoplayTimer = null;
    var currentPage = 0;
    var totalPages = 1;
    var isAttached = false;
    var isDestroyed = false;
    var slidePositions = [];
    var quickAddBindings = [];

    function slidesPerView() {
      var w = window.innerWidth;
      if (w >= 990) return Number(settings.colsDesktop) || 4;
      if (w >= 750) return Number(settings.colsTablet) || 2;
      return Number(settings.colsMobile) || 2;
    }

    function carouselActiveForViewport() {
      if (!settings.enabled) return false;
      var bp = settings.breakpoint || 'mobile';
      var w = window.innerWidth;
      if (bp === 'mobile') return w < 750;
      if (bp === 'tablet') return w < 990;
      return true; // desktop/all
    }

    function computePositions() {
      slides = Array.prototype.slice.call(track.querySelectorAll('.afp-card') || []);
      slidePositions = [];
      var trackRect = track.getBoundingClientRect();
      slides.forEach(function (s) {
        var rect = s.getBoundingClientRect();
        slidePositions.push((rect.left - trackRect.left) + track.scrollLeft);
      });
    }

    function compute() {
      slides = Array.prototype.slice.call(track.querySelectorAll('.afp-card') || []);
      totalSlides = slides.length;
      var spv = slidesPerView();
      if (spv < 1) spv = 1;
      totalPages = Math.max(1, Math.ceil(totalSlides / spv));
      currentPage = Math.min(currentPage, totalPages - 1);
      computePositions();
      buildDots();
      updateControls();
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (!settings.dots) return;
      for (var i = 0; i < totalPages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Go to slide ' + String(i + 1));
        btn.setAttribute('aria-pressed', i === currentPage ? 'true' : 'false');
        btn.dataset.page = i;
        btn.addEventListener('click', onDotClick);
        dotsWrap.appendChild(btn);
      }
    }

    function onDotClick(e) {
      var p = Number(e.currentTarget.dataset.page);
      goToPage(p);
    }

    function getSlideLeft(index) {
      if (!slidePositions || !slidePositions.length) {
        computePositions();
      }
      return slidePositions[index] || 0;
    }

    function goToPage(page) {
      var spv = slidesPerView();
      var idx = Math.min(page * spv, Math.max(0, totalSlides - 1));
      var left = getSlideLeft(idx);
      try { track.scrollTo({ left: left, behavior: 'smooth' }); }
      catch (e) { track.scrollLeft = left; }
      currentPage = page;
      updateDots();
      updateControls();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var buttons = Array.prototype.slice.call(dotsWrap.children || []);
      buttons.forEach(function (b, i) {
        b.setAttribute('aria-pressed', i === currentPage ? 'true' : 'false');
      });
    }

    function updateControls() {
      if (!settings.arrows) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      } else {
        if (prevBtn) prevBtn.style.display = '';
        if (nextBtn) nextBtn.style.display = '';
      }
      if (prevBtn) prevBtn.disabled = currentPage <= 0 && !settings.loop;
      if (nextBtn) nextBtn.disabled = currentPage >= totalPages - 1 && !settings.loop;
    }

    function onPrev() {
      var next = Math.max(0, currentPage - 1);
      if (currentPage === 0 && settings.loop) next = totalPages - 1;
      goToPage(next);
    }

    function onNext() {
      var next = Math.min(totalPages - 1, currentPage + 1);
      if (currentPage >= totalPages - 1 && settings.loop) next = 0;
      goToPage(next);
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var left = track.scrollLeft;
        var spv = slidesPerView();
        var page = 0;
        for (var i = 0; i < totalPages; i++) {
          var idx = i * spv;
          var pos = getSlideLeft(idx);
          if (left + 1 >= pos) page = i;
        }
        currentPage = Math.min(totalPages - 1, page);
        updateDots();
        updateControls();
      });
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var wasActive = isAttached;
        var shouldBeActive = carouselActiveForViewport();
        compute();
        if (shouldBeActive && !wasActive) {
          attach();
        } else if (!shouldBeActive && wasActive) {
          detach();
        }
      }, 120);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!settings.autoplay) return;
      autoplayTimer = setInterval(function () {
        var next = currentPage + 1;
        if (next >= totalPages) {
          if (settings.loop) next = 0;
          else { stopAutoplay(); return; }
        }
        goToPage(next);
      }, Number(settings.autoplaySpeed) || 4000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function onTrackKeydown(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); onPrev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); onNext(); }
    }

    function attach() {
      if (isAttached || isDestroyed) return;
      isAttached = true;
      compute();
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
      if (prevBtn) prevBtn.addEventListener('click', onPrev);
      if (nextBtn) nextBtn.addEventListener('click', onNext);
      track.addEventListener('keydown', onTrackKeydown);

      if (settings.autoplay && settings.pauseOnHover) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('focusin', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        root.addEventListener('focusout', startAutoplay);
      }
      startAutoplay();
      slides.forEach(function (s) { s.setAttribute('tabindex', '-1'); });
      updateControls();
    }

    function detach() {
      if (!isAttached) return;
      isAttached = false;
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      track.removeEventListener('keydown', onTrackKeydown);
      root.removeEventListener('mouseenter', stopAutoplay);
      root.removeEventListener('focusin', stopAutoplay);
      root.removeEventListener('mouseleave', startAutoplay);
      root.removeEventListener('focusout', startAutoplay);
      if (dotsWrap) {
        Array.prototype.slice.call(dotsWrap.children || []).forEach(function (b) {
          b.removeEventListener('click', onDotClick);
        });
      }
      stopAutoplay();
      clearTimeout(resizeTimer);
      resizeTimer = null;
      if (raf) cancelAnimationFrame(raf);
      raf = null;
      slides.forEach(function (s) { s.removeAttribute('tabindex'); });
    }

    // ------- Dynamic modes (no collection required) -------
    function getRecentHandles(max) {
      try {
        var list = JSON.parse(localStorage.getItem('abrsm_recent_products') || '[]');
        var seen = {};
        var out = [];
        for (var i = list.length - 1; i >= 0; i--) {
          var h = list[i];
          if (!seen[h]) { out.push(h); seen[h] = true; }
          if (out.length >= max) break;
        }
        return out;
      } catch (e) { return []; }
    }

    function getPopularHandles(max) {
      try {
        var map = JSON.parse(localStorage.getItem('abrsm_view_counts') || '{}');
        var pairs = Object.keys(map).map(function (k) { return [k, map[k]]; });
        pairs.sort(function (a, b) { return (b[1] || 0) - (a[1] || 0); });
        var out = [];
        for (var i = 0; i < pairs.length && out.length < max; i++) out.push(pairs[i][0]);
        return out;
      } catch (e) { return []; }
    }

    function recordView(handle) {
      if (!handle) return;
      try {
        var arr = JSON.parse(localStorage.getItem('abrsm_recent_products') || '[]');
        arr.push(handle);
        if (arr.length > 200) arr = arr.slice(-200);
        localStorage.setItem('abrsm_recent_products', JSON.stringify(arr));
      } catch (e) {}
      try {
        var counts = JSON.parse(localStorage.getItem('abrsm_view_counts') || '{}');
        counts[handle] = (counts[handle] || 0) + 1;
        localStorage.setItem('abrsm_view_counts', JSON.stringify(counts));
      } catch (e) {}
    }

    function bindQuickAddForms(scope) {
      Array.prototype.slice.call((scope || root).querySelectorAll('.afp-quick-add')).forEach(function (form) {
        if (form.dataset.afpQuickAddBound === 'true') return;
        form.dataset.afpQuickAddBound = 'true';

        var onSubmit = function (event) {
          event.preventDefault();

          var submitBtn = form.querySelector('button[type="submit"]');
          if (!submitBtn) return;

          var payload = new FormData(form);
          payload.set('quantity', '1');

          submitBtn.disabled = true;
          submitBtn.classList.add('is-loading');

          fetch('/cart/add.js', {
            method: 'POST',
            body: payload,
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
            .then(function (response) { return response.json(); })
            .then(function (data) {
              if (data && data.status === 422) {
                throw new Error(data.description || 'Unable to add item to cart.');
              }

              form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: data,
                  addToCartBtn: submitBtn
                },
                bubbles: true
              }));
            })
            .catch(function (error) {
              console.warn('Featured collection quick add failed.', error);
            })
            .finally(function () {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-loading');
            });
        };

        form.addEventListener('submit', onSubmit);
        quickAddBindings.push({ form: form, onSubmit: onSubmit });
      });
    }

    function buildCardHTML(p) {
      // p = product JSON from /products/<handle>.js
      var available = !!p.available;
      var firstAvail = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) { firstAvail = p.variants[i]; break; }
      }
      if (!firstAvail && p.variants && p.variants.length) firstAvail = p.variants[0];

      var priceMin = Infinity, compareMax = 0;
      for (var j = 0; j < p.variants.length; j++) {
        priceMin = Math.min(priceMin, Number(p.variants[j].price) || 0);
        compareMax = Math.max(compareMax, Number(p.variants[j].compare_at_price) || 0);
      }
      var onSale = compareMax > priceMin && compareMax > 0;
      var img1 = (p.images && p.images[0]) ? p.images[0] : null;
      var img2 = (p.images && p.images[1]) ? p.images[1] : null;

      function imgTag(src, extraClass) {
        if (!src) return '';
        var q = src.indexOf('?') > -1 ? '&' : '?';
        var s360 = src + q + 'width=360';
        var s540 = src + q + 'width=540';
        var s700 = src + q + 'width=700';
        var s900 = src + q + 'width=900';
        var s1200 = src + q + 'width=1200';
        return '<img class="afp-card__img '+ extraClass +'" src="'+ s700 +'" alt="'+ (p.title || '') +'"' +
               ' loading="lazy" decoding="async"' +
               ' sizes="(min-width: 1200px) 22vw, (min-width: 990px) 28vw, (min-width: 750px) 33vw, 80vw"' +
               ' srcset="'+ s360 +' 360w, '+ s540 +' 540w, '+ s700 +' 700w, '+ s900 +' 900w, '+ s1200 +' 1200w">';
      }

      var vendorHTML = settings.showVendor && p.vendor ? '<div class="afp-card__vendor"></div>' : '';
      var badgesHTML = '';
      if (settings.showBadges) {
        badgesHTML += '<div class="afp-card__badges" aria-hidden="true">';
        if (onSale) badgesHTML += '<span class="afp-badge">Sale</span>';
        if (!available) badgesHTML += '<span class="afp-badge">Sold out</span>';
        badgesHTML += '</div>';
      }

      var priceHTML = '';
      if (onSale) {
        priceHTML = '<span class="afp-card__price afp-card__price--sale">'+ formatMoneyFromCents(priceMin, settings.currency) +'</span>' +
                    '<span class="afp-card__price afp-card__price--compare">'+ formatMoneyFromCents(compareMax, settings.currency) +'</span>';
      } else {
        priceHTML = '<span class="afp-card__price">'+ formatMoneyFromCents(priceMin, settings.currency) +'</span>';
      }

      var oneClick = settings.quickAdd && available && p.variants && p.variants.length === 1 && firstAvail;
      var ctaHTML = oneClick
        ? ('<form method="post" action="/cart/add" class="afp-quick-add" data-afp-quick-add>' +
            '<input type="hidden" name="id" value="'+ (firstAvail ? firstAvail.id : '') +'">' +
            '<button class="afp-btn" type="submit" aria-label="'+ settings.ctaAddLabel +': '+ (p.title || '') +'">'+ settings.ctaAddLabel +'</button>' +
          '</form>')
        : ('<a class="afp-btn afp-btn--ghost" href="'+ (p.url || '/products/'+ p.handle) +'" aria-label="'+ settings.ctaViewLabel +': '+ (p.title || '') +'">'+ settings.ctaViewLabel +'</a>');

      return '' +
      '<article class="afp-card'+ (available ? '' : ' is-soldout') + (onSale ? ' is-sale' : '') +'">' +
        '<a class="afp-card__media" href="'+ (p.url || '/products/'+ p.handle) +'" aria-label="'+ (p.title || '') +'">' +
          '<div class="afp-card__image-mask">' +
            (img1 ? imgTag(img1, 'afp-card__img--primary') : '') +
            ((settings.showSecond && img2) ? imgTag(img2, 'afp-card__img--secondary') : '') +
          '</div>' +
          '<div class="afp-card__overlay"></div>' +
          badgesHTML +
        '</a>' +
        '<div class="afp-card__info">' +
          (settings.showVendor && p.vendor ? ('<div class="afp-card__vendor">'+ p.vendor +'</div>') : '') +
          '<h3 class="afp-card__title"><a href="'+ (p.url || '/products/'+ p.handle) +'">'+ (p.title || '') +'</a></h3>' +
          '<div class="afp-card__meta">'+ priceHTML +'</div>' +
          '<div class="afp-card__cta">' + ctaHTML + '</div>' +
        '</div>' +
      '</article>';
    }

    function hydrateDynamic() {
      var handles = [];
      if (settings.dataMode === 'recently_viewed') handles = getRecentHandles(limit);
      else if (settings.dataMode === 'popular_viewed') handles = getPopularHandles(limit);

      if (!handles.length) {
        // keep skeletons; nothing to do
        return compute(); // still compute sizing for carousel controls
      }
      // Fetch each product JSON and render
      var requests = handles.slice(0, limit).map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      });

      Promise.all(requests).then(function (items) {
        if (isDestroyed) return;
        var html = '';
        items.forEach(function (p) {
          if (p && p.handle) html += buildCardHTML(p);
        });
        if (html) {
          track.innerHTML = html;
          // Apply smart breaks if enabled
          if (settings.smartBreaks) {
            Array.prototype.slice.call(track.querySelectorAll('.afp-card__title')).forEach(smartBreakTitle);
          }
          bindQuickAddForms(track);
        }
        compute();
        if (carouselActiveForViewport()) attach(); // ensure attached after hydration
      }).catch(function () {
        compute();
      });
    }

    // Smart breaks for Liquid-rendered titles
    if (settings.smartBreaks) {
      Array.prototype.slice.call(track.querySelectorAll('.afp-card__title')).forEach(smartBreakTitle);
    }
    bindQuickAddForms(track);

    // Record view if we're on a product page
    (function () {
      if (!settings.recordViews) return;
      var currentHandle = null;
      // Try ShopifyAnalytics meta first
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.handle) {
        currentHandle = ShopifyAnalytics.meta.product.handle;
      }
      // Liquid-safe fallback if this section is on a product template
      if (!currentHandle) currentHandle = config.productHandle || null;
      if (currentHandle) recordView(currentHandle);
    })();

    // Initialize according to current viewport
    try {
      if (settings.dataMode !== 'collection') {
        // Dynamic modes: hydrate from client
        hydrateDynamic();
      } else {
        if (carouselActiveForViewport()) attach();
        else compute();
      }
    } catch (e) { console.error(e); }

    // Public API for theme editor cleanup
    return {
      destroy: function () {
        isDestroyed = true;
        detach();
        quickAddBindings.forEach(function (binding) {
          binding.form.removeEventListener('submit', binding.onSubmit);
          delete binding.form.dataset.afpQuickAddBound;
        });
        quickAddBindings = [];
        try {
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
          if (dotsWrap) dotsWrap.innerHTML = '';
        } catch (e) { /* no-op */ }
      }
    };
  })(root);
  window._abrsmFeatured[sectionId] = instance;
  root.dataset.afpRuntimeInitialized = 'true';
  return instance;
};

const collectRoots = (scope = document) => {
  const roots = [];
  if (scope.matches?.(rootSelector)) roots.push(scope);
  scope.querySelectorAll?.(rootSelector).forEach((root) => roots.push(root));
  return roots;
};

const initAll = (scope = document) => {
  collectRoots(scope).forEach(initFeaturedCollection);
};

const destroyWithin = (scope) => {
  collectRoots(scope).forEach((root) => {
    const sectionId = String(root.dataset.sectionId || '');
    const instance = window._abrsmFeatured?.[sectionId];
    if (typeof instance?.destroy === 'function') instance.destroy();
    if (window._abrsmFeatured && sectionId) delete window._abrsmFeatured[sectionId];
    delete root.dataset.afpRuntimeInitialized;
  });
};

document.addEventListener('shopify:section:load', (event) => initAll(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

window.__abrsmFeaturedCollectionRuntime = { initAll, destroyWithin };
initAll();
})();
